import BetOddsWrapper from "../../common/BetOddsWrapper";
import BettingClosedMessage from "../../common/BettingClosedMessage";
import BetWrapper from "../../common/BetWrapper";
import ButtonsScroller from "../../common/ButtonsScroller";
import Img from "../../common/Img";
import OddWithDesc from "../../common/OddWithDesc";
import { classIf } from "../../data/utils";
import { getScores } from "../scores/scores";
import StreamingToggle from "./StreamingToggle";

export default function Event(props) {
    const data = props.data;
    const [header, scoresTeam1, scoresTeam2] = getScores(data.score, 'c_18_1_4_1', 'c_18_2_1_3_1');

    return (
        <div className="c_17">
            <div className="c_17_1">
                <div className="c_18" data-live>
                    <div className="c_18_1">
                        <span className="c_18_1_2">{data.sportDesc} | {data.categoryDesc} | {data.tournamentDesc}</span>
                        <div className="c_18_1_4">{header}</div>
                        <div className="c_18_1_3">
                            <Img className="c_18_1_3_1" src="icon_streaming.svg" height="32px" width="32px" onClick={() => props.toggleWidget('live-tracker', data)} />
                            <StreamingToggle className="c_18_1_3_1"
                                             data={data}
                                             toggle={() => props.toggleWidget('streaming', data)}
                            />
                            <Img className="c_18_1_3_1" src="icon_close.svg" height="32px" width="32px" onClick={props.close} />
                        </div>
                    </div>
                    <div className="c_18_2">
                        <div className="c_18_2_1">
                            <div className="c_18_2_1_1">{data.score?.periodo}</div>
                            <div className="c_18_2_1_2">{data.team1}</div>
                            <div className="c_18_2_1_3">{scoresTeam1}</div>
                            <div className="c_18_2_1_4"></div>
                        </div>
                        <div className="c_18_2_1">
                            <div className="c_18_2_1_1">{data.score?.currentMinute}</div>
                            <div className="c_18_2_1_2">{data.team2}</div>
                            <div className="c_18_2_1_3">{scoresTeam2}</div>
                            <div className="c_18_2_1_4"></div>
                        </div>
                    </div>
                </div>
                <ButtonsScroller>
                    {data.gruppiScommessa.map(a =>
                        <div key={a.idAggregata} className={"c_20_2_1" + classIf(data.aggId === a.idAggregata, 'active')} onClick={() => props.changeAgg(a.idAggregata)}>{a.descrizione}</div>
                    )}
                </ButtonsScroller>
            </div>
            {data.giocabilita === false ?
                <BettingClosedMessage />
                :
                <div className="c_17_2">
                    {data.bets.map(b => {
                        if (!b.hasOdds) {
                            return null;
                        }

                        return (
                            <BetWrapper key={b.uniqueId} data={b} toggled={true}>
                                <BetOddsWrapper>
                                    {b.odds.map(o => {
                                        if (o.value == null) {
                                            return null;
                                        }
                                        return <OddWithDesc key={o.uniqueId} data={o} />;
                                    })}
                                </BetOddsWrapper>
                            </BetWrapper>
                        );
                    })}
                </div>
            }
        </div>
    );
}
